import { z } from 'zod';

import { MemberProductSchema } from '../member-product/member-product';
import { BillingPlanModeSchema } from '../plan-mode/plan-mode';

/**
 * Everything the paywall needs in one answer: the plans, and the mode that says
 * how to read them.
 *
 * ## Why the mode is here and not on the row
 *
 * It is one fact about the deployment, not a property of a plan. Repeating it
 * per product invites a client that reads it off row zero — which is correct
 * until the catalogue is empty, and then the screen has no mode at all on the
 * one state where it still has to say something.
 *
 * The wrapper is also what makes the empty catalogue honest: `products: []` with
 * a known mode is "your gender is sold nothing", which is a finished answer.
 */
export const MemberProductCatalogSchema = z
  .object({
    planMode: BillingPlanModeSchema,
    products: z.array(MemberProductSchema),
  })
  .strict();

export type MemberProductCatalog = z.infer<typeof MemberProductCatalogSchema>;
